import type { ExportOrderSource } from '@/components/modals/ExportOrderModal'
import { useResidentModalsApi } from '@/components/modals/ResidentModals'
import { selectUserConfiguration } from '@/features/domain/user'
import { useSelector } from 'react-redux'

export function useExportOrderButtonData(
  extOrder: uui.domain.client.rm.ExtendedOrderStep,
  source: ExportOrderSource = 'configuration',
) {
  const {
    exportOrders: { show: showExportOrderModal },
  } = useResidentModalsApi()

  const { startFromDate, planType } = useSelector(selectUserConfiguration)

  // Get date from extOrder - it has dateAsString when assigned, or we use startFromDate as fallback for unassigned
  const date = extOrder.isUnassigned ? startFromDate : extOrder.dateAsString

  const orderInArchivedDay = date < startFromDate

  return {
    exportOrder: () =>
      showExportOrderModal(
        source,
        [extOrder.id],
        [extOrder],
        date,
        planType === 'simulation' ? 'simulation' : orderInArchivedDay ? 'archived' : 'operations',
      ),
  }
}
